function Timeline (el){

    this.element = el;

    this.autorenew_route = null;
    this.autorenew_timestamp = null;
    this.autorenew_interval = 60 * 1000;

    this.waypoint_route = null;
    this.waypoint_timestamp = null;
    this.waypoint_instance = null;

    this.initRefreshTimeline = function(route, timestamp, interval){

        this.autorenew_timestamp = timestamp;
        this.autorenew_route = route;

        if(interval){
            this.autorenew_interval = interval;
        }

        setInterval(function(){
            this.refreshTimeline()
        }.bind(this), this.autorenew_interval);
    }

    this.initWaypointTimeline = function(route, timestamp){

        this.waypoint_route = route;
        this.waypoint_timestamp = timestamp;

        this.waypoint_instance = $('.timeline-end', this.element).waypoint({
            offset: 'bottom-in-view',
            handler: function (direction) {

                if (direction == 'down') {

                    $('.timeline-end').addClass('loading');

                    $.get(this.waypoint_route,
                        {
                            'older_than': this.waypoint_timestamp
                        },
                        function (response) {
                            if (response.success == true) {

                                $.each(response.data.posts, function (key, post) {
                                    var el = $(post.html);
                                    $('.timeline-items').append(el);
                                    $('.boost-post-ajax', el).on('click', boost_post);
                                    initReplyTextarea(el);
                                    initLoadMoreReplies(el)
                                    initDeletePost(el);
                                    initAddGoal(el);
                                    initBroadcastReplyEvent(post.channel);
                                    initBoostGoal(el);
                                });

                                if (response.data.timestamp_last != null) {
                                    this.waypoint_timestamp = response.data.timestamp_last;
                                    this.waypoint_instance[0].context.refresh();
                                } else {
                                    this.waypoint_timestamp = null;
                                    this.waypoint_instance[0].context.destroy();
                                }

                                $('[data-toggle=tooltip]').tooltip();

                            } else {
                                systemalert(response.message, 'warning');
                            }

                            $('.timeline-end').removeClass('loading');
                        }
                        .bind(this),
                        'json'
                    )
                    .fail(function () {
                        $(this).attr('disabled', false);
                        systemalert('There was an system error, please notify an admin!', 'danger');

                        $('.timeline-end').removeClass('loading');
                    });

                }
            }.bind(this)
        });

    }

    this.initBroadcastPostEvent = function(socket, channel){
        socket.on(channel + ':App\\Events\\Broadcasts\\BroadcastPostEvent', function (data) {

            var el = $(data.html);
            $('.timeline-items', this.element).prepend(
                el
            );
            $('.boost-post-ajax', el).on('click', boost_post);
            initLoadMoreReplies(el)
            initReplyTextarea(el);
            initDeletePost(el);
            initAddGoal(el);
            initBoostGoal(el);
            initBroadcastReplyEvent(data.post.channel);

            this.autorenew_timestamp = data.post.created_at;

            $('[data-toggle=tooltip]').tooltip();

        }.bind(this));
    }

    this.refreshTimeline = function(){
        $.get(this.autorenew_route, {
            'newer_than': this.autorenew_timestamp
        },
        function (response) {
            if (response.success == true) {
                $.each(response.data.posts, function (key, post) {
                    var el = $(post.html);
                    $('.timeline-items').prepend(el);
                    $('.boost-post-ajax', el).on('click', boost_post);
                    initLoadMoreReplies(el)
                    initReplyTextarea(el);
                    initDeletePost(el);
                    initAddGoal(el);
                    initBoostGoal(el);
                    initBroadcastReplyEvent(post.channel);
                });

                if (response.data.timestamp_first != null) {
                    this.autorenew_timestamp = response.data.timestamp_first
                }

                $('[data-toggle=tooltip]').tooltip();
            } else {
                systemalert(response.message, 'warning'); 
            }
        }
        .bind(this), 'json')
        .fail(function () {
            $(this).attr('disabled', false);
            systemalert('There was an system error, please notify an admin!', 'danger');
        })
    }


}